export enum UsersTypes {
  Student = 2,
  Guardian = 3,
  Teacher = 4,
  Employee = 5,
  SuperAdmin = 100
}

export enum UserTypes {
  student = 2,
  parent = 3,
  teacher = 3,
  supervisor = 5,
  monitor = 6,
  manager = 7,
  administrator = 8,
  employee = 9,
  owner = 10
}
